import React from "react";

/**
 * External link component that renders the "GoAndTrack" wordmark as a
 * hyperlink to https://goandtrack.com/ in a new tab.
 * Use directly in JSX: <GoAndTrackLink />
 */
export function GoAndTrackLink({ className = "" }) {
  return (
    <a
      href="https://goandtrack.com/"
      target="_blank"
      rel="noopener noreferrer"
      className={`underline decoration-cobalt/40 underline-offset-4 hover:decoration-cobalt hover:text-cobalt transition-colors ${className}`.trim()}
      data-testid="goandtrack-link"
    >
      GoAndTrack
    </a>
  );
}

/**
 * Given a plain string that *may* contain the word "GoAndTrack", returns
 * a React fragment that splits the string on every occurrence and inserts
 * a <GoAndTrackLink /> in place. Use for strings that live inside data
 * arrays/objects and are rendered as {item.value}.
 *
 *   <p>{linkifyGoAndTrack(item.description)}</p>
 */
export function linkifyGoAndTrack(text) {
  if (typeof text !== "string" || !text.includes("GoAndTrack")) return text;
  const parts = text.split("GoAndTrack");
  return parts.map((part, i) => (
    <React.Fragment key={i}>
      {part}
      {i < parts.length - 1 && <GoAndTrackLink />}
    </React.Fragment>
  ));
}
